import {css} from "@panda/css";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesCityHero} from "../components/PricesCityHero";
import {PricesContextFilterProvider} from "../components/PricesContextFilterProvider";
import {PricesDifferences} from "../components/PricesDifferences";
import {PricesDistricts} from "../components/PricesDistricts";
import {PricesGlossary} from "../components/PricesGlossary";
import {PricesMethodology} from "../components/PricesMethodology";
import {PricesOffers} from "../components/PricesOffers";
import {PricesRegionsFAQ} from "../components/PricesRegionsFAQ";
import {PricesTrend} from "../components/PricesTrend";
import {PricesViewType} from "../helpers/prices_view_type";
import {useMirrorPricesRecentToMainSearch} from "../hooks/use_mirror_prices_recent_to_main_search";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";

interface Props {
    type: PricesViewType;
    region: IRegionReportPrice;
    district: IRegionReportPrice | null;
}

export const PricesRegionLayout = (props: Props) => {
    const displayRegion = props.district ?? props.region;
    const analyticsLocation: PricesCityAnalyticsLocation = props.district ? "rp_apartment_prices_district" : "rp_apartment_prices_city";

    useMirrorPricesRecentToMainSearch(displayRegion.id);

    return (
        <div>
            <PricesBreadcrumbs type={props.type} region={props.region} district={props.district} className={breadcrumbsStyle} />

            <PricesCityHero region={displayRegion} />

            <PricesContextFilterProvider>
                <PricesDifferences region={displayRegion} location={analyticsLocation} />

                <PricesTrend region={displayRegion} location={analyticsLocation} />
                {
                    // hidden for now to use in future
                    //<PricesCalculator region={displayRegion} location={analyticsLocation} />
                }

                {!props.district && <PricesDistricts region={props.region} type={props.type} />}
            </PricesContextFilterProvider>

            <PricesGlossary location={analyticsLocation} />

            <PricesOffers region={displayRegion} type={props.type} showDistrictFilter={!props.district} location={analyticsLocation} />

            <div className={css({backgroundColor: "var(--colors-gray-200)"})}>
                {!props.district && <PricesRegionsFAQ region={props.region} type={props.type} />}

                <PricesMethodology />
            </div>
        </div>
    );
};

const breadcrumbsStyle = css({
    backgroundColor: "var(--colors-white)",
    py: 2
});
import {css} from "@panda/css";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesCityHero} from "../components/PricesCityHero";
import {PricesContextFilterProvider} from "../components/PricesContextFilterProvider";
import {PricesDifferences} from "../components/PricesDifferences";
import {PricesDistricts} from "../components/PricesDistricts";
import {PricesGlossary} from "../components/PricesGlossary";
import {PricesMethodology} from "../components/PricesMethodology";
import {PricesOffers} from "../components/PricesOffers";
import {PricesRegionsFAQ} from "../components/PricesRegionsFAQ";
import {PricesTrend} from "../components/PricesTrend";
import {PricesViewType} from "../helpers/prices_view_type";
import {useMirrorPricesRecentToMainSearch} from "../hooks/use_mirror_prices_recent_to_main_search";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";

interface Props {
    type: PricesViewType;
    region: IRegionReportPrice;
    district: IRegionReportPrice | null;
}

export const PricesRegionLayout = (props: Props) => {
    const displayRegion = props.district ?? props.region;
    const analyticsLocation: PricesCityAnalyticsLocation = props.district ? "rp_apartment_prices_district" : "rp_apartment_prices_city";

    useMirrorPricesRecentToMainSearch(displayRegion.id);

    return (
        <div>
            <PricesBreadcrumbs type={props.type} region={props.region} district={props.district} className={breadcrumbsStyle} />

            <PricesCityHero region={displayRegion} />

            <PricesContextFilterProvider>
                <PricesDifferences region={displayRegion} location={analyticsLocation} />

                <PricesTrend region={displayRegion} location={analyticsLocation} />
                {
                    // hidden for now to use in future
                    //<PricesCalculator region={displayRegion} location={analyticsLocation} />
                }

                {!props.district && <PricesDistricts region={props.region} type={props.type} />}
            </PricesContextFilterProvider>

            <PricesGlossary location={analyticsLocation} />

            <PricesOffers region={displayRegion} type={props.type} showDistrictFilter={!props.district} location={analyticsLocation} />

            <div className={css({backgroundColor: "var(--colors-gray-200)"})}>
                {!props.district && <PricesRegionsFAQ region={props.region} type={props.type} />}

                <PricesMethodology />
            </div>
        </div>
    );
};

const breadcrumbsStyle = css({
    backgroundColor: "var(--colors-white)",
    py: 2
});
